import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/helpers/hooks';
import * as actions from 'app/actions/customer';
import { selectCustomerReferralSourcesOptions } from 'app/selectors/customer';
import { FullscreenModal } from 'app/components/common/FullscreenModal.jsx';
import { Button, Card, IntakeCheckbox, PageWrapper } from 'mui';

const CheckboxCustom = ({ title, value, selectedOptions, setSelectedOptions, ...restProps }) => {
  const handleChange = (e) => {
    if (e.target.checked) {
      setSelectedOptions([...selectedOptions, value]);
    } else {
      setSelectedOptions(selectedOptions.filter((option) => option !== value));
    }
  };

  return (
    <IntakeCheckbox
      label={title}
      checked={selectedOptions.includes(value)}
      onChange={handleChange}
      testid={value}
      {...restProps}
    />
  );
};

const getCheckbox = (option, selectedOptions, setSelectedOptions, index) => {
  const title = (
    <>
      {option.label}
      {!!option.sub_label && <span> {option.sub_label}</span>}
    </>
  );

  return (
    <CheckboxCustom
      key={index}
      title={title}
      value={option.name}
      selectedOptions={selectedOptions}
      setSelectedOptions={setSelectedOptions}
    />
  );
};

const ModalTitle = () => (
  <>
    <h3 className="hidden md:block md:visible">How did you hear about Maximus?</h3>
    <h4 className="md:hidden">How did you hear about Maximus?</h4>
  </>
);

const ModalBody = () => {
  const dispatch = useAppDispatch();
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const options = useAppSelector(selectCustomerReferralSourcesOptions).toJS();
  const [otherInput, setOtherInput] = useState('');

  const submit = () => {
    if (!selectedOptions.length) {
      return;
    }
    let userOptions = selectedOptions.reduce((obj, option) => ({ ...obj, [option]: true }), {});
    if (selectedOptions.includes('other')) {
      userOptions = { ...userOptions, other_content: otherInput };
    }
    const cmdType = 'answer_questions';
    const params = { referral_sources: userOptions };
    const action = actions.apiRequestUserCommand({
      cmdType,
      params,
      context: {},
    });
    dispatch(action);
  };

  const getOtherTitle = () => {
    return selectedOptions.includes('other') ? (
      <input
        className="w-full"
        type="text"
        value={otherInput}
        onChange={(e) => setOtherInput(e.target.value)}
        placeholder="Please list"
        autoFocus // eslint-disable-line jsx-a11y/no-autofocus
      />
    ) : (
      <>
        Other
        <span> (please list)</span>
      </>
    );
  };

  return (
    <Card>
      <Card.Body>
        <div className="flex flex-col gap-y-4">
          {options.map((option, index) => getCheckbox(option, selectedOptions, setSelectedOptions, index))}
          <div className="[&_.intake-checkbox-label]:flex-1">
            <CheckboxCustom
              title={getOtherTitle()}
              value="other"
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
              labelClassName="w-full"
            />
          </div>
        </div>
        <Button data-testid="referral-source" onClick={submit} disabled={!selectedOptions.length}>
          Next
        </Button>
      </Card.Body>
    </Card>
  );
};

const ReferralSourcesModal = () => {
  return (
    <FullscreenModal
      text={
        <PageWrapper wrapperClassName="flex flex-col gap-y-6 lg:gap-y-8 py-8 md:py-12 !pb-[140px]">
          <ModalTitle />
          <ModalBody />
        </PageWrapper>
      }
    />
  );
};

export default ReferralSourcesModal;
